import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./CircleLoader.module.scss";
export const CircleLoader = ({ dataTestId, width = 35, className }) => {
    return (_jsxs("svg", { "data-testid": dataTestId, className: classNames(styles.svgContainer, className), viewBox: "25 25 50 50", width: `${width}px`, children: [_jsx("circle", { className: styles.circleGrey, r: "20", cy: "50", cx: "50" }), _jsx("circle", { className: styles.circleBlack, r: "20", cy: "50", cx: "50" })] }));
};
//# sourceMappingURL=CircleLoader.js.map